// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("sifter")
require("microplugin")


require("packs/language")
require("packs/validar_nombres")
require("jquery")


import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"


Rails.start()  // <-- Asegúrate de que esta línea esté aquí
Turbolinks.start()
ActiveStorage.start()




import '../js/bootstrap_js_files.js' 



import "../stylesheets/mi-css";



import 'bootstrap-icons/font/bootstrap-icons.css'




